module.exports = __webpack_public_path__ + "img/iconfont.13b90fe6.svg";